import { render, staticRenderFns } from "./AudioWidget.vue?vue&type=template&id=58c0fb09&scoped=true"
import script from "./AudioWidget.vue?vue&type=script&lang=js"
export * from "./AudioWidget.vue?vue&type=script&lang=js"
import style0 from "./AudioWidget.vue?vue&type=style&index=0&id=58c0fb09&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c0fb09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c0fb09')) {
      api.createRecord('58c0fb09', component.options)
    } else {
      api.reload('58c0fb09', component.options)
    }
    module.hot.accept("./AudioWidget.vue?vue&type=template&id=58c0fb09&scoped=true", function () {
      api.rerender('58c0fb09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/AudioWidget.vue"
export default component.exports